import { render } from "./FinalEvaluation.vue?vue&type=template&id=41d4c372&scoped=true"
import script from "./FinalEvaluation.vue?vue&type=script&lang=js"
export * from "./FinalEvaluation.vue?vue&type=script&lang=js"

import "./final-evaluation.scss?vue&type=style&index=0&id=41d4c372&lang=scss&scoped=true"

import exportComponent from "/var/www/html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d4c372"]])

export default __exports__